import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataField, H2 } from "../../components/common-components";
import { getCurrentUserDetails } from "../../../../redux/modules/user/actions";
import { getPharmacistInfo, getPharmacyInfo } from "../../common/getPharmacyInfo";

const CLINICAL_SERVICE_DISPLAY_NAMES = {
  annualmedicationreview: "Annual Medication Review",
  medicationreview: "Annual Medication Review",
  allergicRhinitis: "Allergic Rhinitis",
  allergicrhinitis: "Allergic Rhinitis",
};

const resolveServiceDisplayName = (value) => {
  if (!value) return "";
  const key = String(value).toLowerCase().replace(/[\s_-]/g, "");
  return CLINICAL_SERVICE_DISPLAY_NAMES[key] || value;
};

export const InterventionPatientSections = ({ clinicalServiceName = "", documentation = {} }) => {
  const dispatch = useDispatch();
  const { currentLoggedInUserDetail: userFromCurrentState } = useSelector(
    (state) => state.currentLoggedInUserDetail ?? {}
  );
  const usersState = useSelector((state) => state.users ?? {});
  const { currentLoggedInUserDetail: userFromUsers, pharmacyStores } = usersState;
  const currentLoggedInUserDetail = userFromCurrentState ?? userFromUsers;

  useEffect(() => {
    if (!currentLoggedInUserDetail) {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo") || "{}");
      const userId = userInfo.userId;
      if (userId) {
        dispatch(getCurrentUserDetails(userId, false));
      }
    }
  }, [currentLoggedInUserDetail, dispatch]);

  const provider = documentation?.notificationInformations && documentation.notificationInformations.length > 0
    ? documentation.notificationInformations[0]
    : null;

  const providerName = provider
    ? [provider.lastName, provider.firstName, provider.middleName].filter(Boolean).join(' ')
    : "";

  const designation = provider?.designation || provider?.title || "";

  const pharmacist = getPharmacistInfo(currentLoggedInUserDetail) ?? {};
  const pharmacy = getPharmacyInfo(currentLoggedInUserDetail, pharmacyStores) ?? {};

  const phone = pharmacy?.pharmacyPhone || provider?.phoneNumber || provider?.telephone || provider?.primaryPhone || "";
  const fax = pharmacy?.pharmacyFax || provider?.fax || provider?.faxNumber || "";
  const email = pharmacy?.pharmacyEmail || provider?.emailAddress || provider?.email || "";
  const licence = pharmacist?.pharmacistLicenseNumber || provider?.licenseNumber || provider?.license || provider?.licenceNumber || "";
  const displayClinicalServiceName = resolveServiceDisplayName(clinicalServiceName) || "Patient Chart";
  return (
    <div className="space-y-0">
      <div className="flex bg-gray-10 border border-gray-100">
        <div className="flex-1 py-2">
          <div className="px-4">
            <div className="space-y-1">
              <DataField
                label="Name of Service:"
                value={displayClinicalServiceName}
              />
              <DataField
                label="To"
                value={providerName || designation || ""}
              />
              <p className="text-xs">
                <span className="font-semibold">After an assessment for : </span>
                <span className="font-semibold">[{displayClinicalServiceName}]</span>
                <span>, a drug therapy problem was identified.</span>
              </p>
            </div>
          </div>
        </div>

        <div className="w-px bg-gray-200 my-4"></div>

        <div className="flex-1 py-2">
          <div className="px-4">
            <H2>Prescriber Information</H2>
            <div className="space-y-1">
              <DataField
                label="Primary Phone number"
                value={phone}
              />
              <DataField
                label="Fax"
                value={fax}
              />
              <DataField
                label="Email Address"
                value={email}
              />
              <DataField
                label="Licence Number"
                value={licence}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
